import LocationTemplate from '../models/location-template';

export const LOCATION_TEMPLATES: Array<LocationTemplate> = [LocationTemplate.getInstanceFromObject({
    id: '4fcfd4fc-9d23-4e65-84a3-3b3345625961',
    name: 'Default',
})];
